import { Stack, useMantineTheme } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

import type { CellDescriptor, TableCellBaseType } from '../../types/common';

export type TableColumnTextType = TableCellBaseType & {
  type: 'Text';
  key: string;
  label?: string;
};

export type TableCellDataTextType = {
  value: string;
  label?: string;
};

function TableCellText({ cell }: { cell: TableCellDataTextType }) {
  const theme = useMantineTheme();

  return (
    <Stack spacing={0}>
      {cell.label && (
        <Text variant="headline-medium" c={theme.colors.dark[2]}>
          {cell.label}
        </Text>
      )}
      <Text variant="headline-medium">{cell.value}</Text>
    </Stack>
  );
}

const descriptor: CellDescriptor<TableColumnTextType, TableCellDataTextType> = {
  name: 'Text',
  Cell: TableCellText,
};

export default descriptor;
